export default __webpack_public_path__ + "static/media/KM.18fb1391.svg";